<script>
export default {
  data () {
    return {
      quantity: 1,
      initialQuantity: 1,
      size: null,
      createdPageSize: null,
      product: null,
      links: null,
      filters: null,
      prices: null,
      loading: true,
      userViewingTheProduct: null,
      lastClickFilter: null,
      loadingFilter: null,
      cancelToken: null,
      getingProduct: null,
      disableChangeProduct: false
    }
  },
  computed: {
    checkAddProduct () {
      return this.product.actualStock === 0 || this.quantity <= 0 || this.product.minimalQuantity > this.quantity || (this.product.actualStock === null ? false : this.quantity > this.product.actualStock)
    }
  },
  watch: {
    quantity (quantity) {
      this.getPrices()
      this.$refs.shippingInfo.get(this.product.id, Number(quantity), true)
    }
  },
  methods: {
    startChangeProduct (productId) {
      this.disableChangeProduct = true

      if (this.cancelToken) { this.cancelToken.cancel('Request canceled') }
      this.cancelToken = this.$axios.CancelToken.source()

      this.getingProduct = productId
      if (this.lastClickFilter && this.lastClickFilter.productId === productId) {
        this.loadingFilter = this.lastClickFilter
      }

      if (this.loadingFilter && this.loadingFilter.productId !== productId) {
        this.loadingFilter = null
      }
    },
    finishChangeProduct (productId) {
      this.disableChangeProduct = false

      if (this.loadingFilter && this.loadingFilter.productId === productId) {
        this.loadingFilter = null
      }
    },
    getPrices () {
      const data = { quantity: Number(this.quantity), sizes: this.size, additionalOptions: this.additionalOptions }

      this.$api.default.getPrice(this.product.id, data)
        .then((res) => {
          this.prices = res.summary

          const newSizes = res.summary.sizes
          if (this.$refs.productSizes) {
            this.$refs.productSizes.setModel(newSizes)
          }

          if (res.offScale) {
            switch (newSizes.selected) {
              case 'lowest':
                this.$buefy.toast.open({
                  message: this.$t('products.errors.sizeLowest', { sizes: `${newSizes.width} ${this.sizeType(newSizes)} x ${newSizes.height} ${this.sizeType(newSizes)}` }),
                  type: 'is-warning',
                  duration: 3000,
                  queue: false
                })
                break
              case 'highest':
                this.$buefy.toast.open({
                  message: this.$t('products.errors.sizeHighest', { sizes: `${newSizes.width} ${this.sizeType(newSizes)} x ${newSizes.height} ${this.sizeType(newSizes)}` }),
                  type: 'is-warning',
                  duration: 3000,
                  queue: false
                })
                break
              default:
                break
            }
          } else if (res.divideByZero) {
            this.$buefy.toast.open({
              message: this.$t('products.errors.sizeDivideByZero'),
              type: 'is-warning',
              duration: 3000,
              queue: false
            })
          }
        })
        .catch(({ response }) => {
          switch (response.data.error) {
            case 'SIZE_RANGE_OUT':
              this.$buefy.toast.open({
                message: this.$t('products.errors.sizeRangeOut'),
                type: 'is-danger'
              })
              break

            default:
              break
          }
        })
    },
    addCart () {
      this.$store.dispatch('page/loadingCart', true)

      if (!(this.product.possibilityPrint || this.redirectToCheckout)) {
        this.$store.dispatch('page/isOpenedCart', true)
      }

      this.eventProductAddToCart(this.product, this.prices, this.quantity)

      this.addCartApi()
        .then((res) => {
          if (res.error) {
            this.key++
            if (res.error.message === 'NOT_ENOUGH_QUANTITY') {
              this.$buefy.toast.open({
                message: this.$t('cart.errorQuantity'),
                type: 'is-warning'
              })
            } else {
              this.$buefy.toast.open({
                message: this.$t('cart.errorAdd'),
                type: 'is-danger'
              })
            }
          } else {
            this.$store.dispatch('page/updateCart', res)

            if (this.product.possibilityPrint) {
              this.$router.push(this.localePath({ name: 'print', query: { type: 'oop', id: res.orderOfferProductId } }))
            } else if (this.redirectToCheckout) {
              this.$router.push(this.localePath('checkout'))
            }

            if (this.product.possibilityPrint || this.redirectToCheckout) {
              this.$buefy.toast.open({
                message: this.$t('cart.successAdd'),
                type: 'is-success'
              })
            }
          }
        })
        .catch(({ response }) => {
          switch (response.data.error) {
            case 'SIZE_RANGE_OUT':
              this.$buefy.toast.open({
                message: this.$t('products.errors.sizeRangeOut'),
                type: 'is-danger'
              })
              break

            default:
              this.$buefy.toast.open({
                message: this.$t('cart.errorAdd'),
                type: 'is-danger'
              })
              break
          }
        })
        .finally(() => {
          this.$store.dispatch('page/loadingCart', false)
        })
    },
    resetDataGlobal () {
      this.product = null
      this.links = null
      this.filters = null
      this.prices = null
      this.quantity = 1
      this.initialQuantity = 1
      if (this.$refs.productSizes) {
        this.$refs.productSizes.setModel(null)
      }
      this.userViewingTheProduct = null
      if (this.$refs.shippingInfo) {
        this.$refs.shippingInfo.set(null)
      }
    },
    setDataGlobal (res) {
      // TODO inche sprawdzenie czy to tylko na created
      this.product = res.offerProduct
      this.links = res.links
      this.filters = res.filterStructure
      this.prices = res.offerProduct.summary

      if (this.$refs.productSizes) {
        this.$refs.productSizes.setModel(res.size)
      } else {
        this.size = res.size
      }

      this.userViewingTheProduct = res.user
      this.additionalOptions = this.product.selectedOptions || []

      if ((this.product.actualStock === null || this.product.minimalQuantity <= this.product.actualStock) && this.product.minimalQuantity > 1) {
        this.initialQuantity = this.product.minimalQuantity
      } else {
        this.initialQuantity = 1
      }

      if (this.$refs.shippingInfo) {
        this.$refs.shippingInfo.set(false)
        this.$refs.shippingInfo.get(this.product.id, this.initialQuantity)
      }

      this.$nextTick(() => {
        this.quantity = this.initialQuantity
      })
    },
    setDataGlobalFinish () {
      this.eventProductView(this.product, this.userViewingTheProduct)
    }
  }
}
</script>
